import { useState, useEffect, useRef } from 'react'

const CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789#@$%&!'

export const useTextScramble = (text, trigger, duration = 900) => {
	const [output, setOutput] = useState(text)
	const rafRef = useRef(null)

	useEffect(() => {
		if (!trigger) return

		const startTime = performance.now()

		const animate = (now) => {
			const elapsed = now - startTime
			const progress = Math.min(elapsed / duration, 1)

			let result = ''
			for (let i = 0; i < text.length; i++) {
				if (text[i] === ' ') {
					result += ' '
					continue
				}
				// Stagger reveal: each character unlocks based on its position
				const charReveal = i / text.length
				if (progress > charReveal) {
					// Ease the reveal so it's snappier at the start
					const localProgress = (progress - charReveal) / (1 - charReveal + 0.001)
					if (localProgress > 0.6) {
						result += text[i]
					} else {
						result += CHARS[Math.floor(Math.random() * CHARS.length)]
					}
				} else {
					result += CHARS[Math.floor(Math.random() * CHARS.length)]
				}
			}

			setOutput(result)

			if (progress < 1) {
				rafRef.current = requestAnimationFrame(animate)
			} else {
				setOutput(text)
			}
		}

		rafRef.current = requestAnimationFrame(animate)
		return () => {
			if (rafRef.current) cancelAnimationFrame(rafRef.current)
		}
	}, [trigger, text, duration])

	return output
}
